import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'isHidden',
    standalone: true,
})
export class HiddenPipe implements PipeTransform {
    constructor(public translate: TranslateService) {
        // ...
    }

    transform(bool: string) {
        if (bool) {
            return this.translate.instant('COMMON.NO');
        }

        return this.translate.instant('COMMON.YES');
    }
}
